/* eslint-disable react-hooks/exhaustive-deps */
import * as wjcCore from "@grapecity/wijmo"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"

import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useContext, useEffect, useRef, useState } from "react"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import DateInput from "../../../components/InputWrapper/DateInput"
import TextInput from "../../../components/InputWrapper/TextInput"
import {
  e工程区分,
  e海コン付帯作業区分,
  e請求支払処理状態区分,
  e請求支払確認区分,
} from "../../../constant/enum/zyutuHaisya"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import { EtcDataContext, T作業情報Grid } from "./KaikonZyutyuHaisyaRegister"
import { 区分分類コード } from "../../../constant/enum/codes"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import TumiOrosiSakiSearchModal from "../../../components/SearchModal/TumiOrosiSakiSearchModal"
import SyaryoSearchModal from "../../../components/SearchModal/SyaryoSearchModal"
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"
import SiharaisakiSearchModal from "../../../components/SearchModal/SiharaisakiSearchModal"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import { T積卸先 } from "../../../service/master/tumiorosisaki/TTumiorosisaki"
import {
  get傭車itemsSourceFunctionByApi,
  get積卸ItemsSourceByApi,
  get車輌itemsSourceFunctionByApi,
} from "../../../ts/util/autoCompleteUtil"
import {
  TSyaryoListGetReq,
  TSyaryoModalList,
} from "../../../service/truck/TSyaryo"
import { e車種区分 } from "../../../constant/enum/syaryo"
import _ from "lodash"
import { T支払先 } from "../../../components/ComboBox/SiharaiSakiComboBox"
import { e支払先区分 } from "../../../constant/enum/master"
import { get乗務員 as get乗務員Inner } from "../../../ts/util/haisyaUtil"
import { AppDispatch } from "../../.."
import { setAlerts } from "../../../globalStore/alertStore"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import { T傭車マスタ } from "../../../service/master/yosya/TYosya"
import YosyaSearchModal from "../../../components/SearchModal/YosyaSearchModal"
import dayjs from "dayjs"
import util from "../../../ts/util"
// const 工程Colors = { 1: "#E3F2FD", 2: "#BBDEFB", 3: "#90CAF9", 4: "#64B5F6" }

export type T食事手当 = { name: string; value: number }
const 請求処理状態区分List: string[] = [
  e請求支払処理状態区分.確定,
  e請求支払処理状態区分.送付済,
]

const SagyoGridRow: React.FC<{
  isRestoreSearching: boolean
  initState: T作業情報Grid | undefined
  setState: (v: T作業情報Grid) => unknown
  ninusiCode: string | undefined
  支払先ItemSource: T支払先[] | undefined
  傭車会社コード: string | undefined
  処理伝播用傭車フラグ: number | undefined
  set傭車会社コード: (v: string) => unknown
  請求額確認区分コード?: string
  請求処理状態区分コード?: string
}> = (props) => {
  // ログインユーザ情報
  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )
  const dispatch: AppDispatch = useDispatch()
  // autocompleteの検索がstateの変更に耐えきれるようにrefに格納
  const 荷主コードRef = useRef<string>()
  const pre積卸先コードRef = useRef<string | null>()
  const 運行部所コードRef = useRef<string>()
  const pre車番Ref = useRef<string | null>()
  const preトレーラ車番Ref = useRef<string | null>()

  const EtcData = useContext(EtcDataContext)

  //#region [state]
  const [受注配車ID, set受注配車ID] = useState<number>()
  const [受注配車工程ID, set受注配車工程ID] = useState<number>()
  const [積卸日, set積卸日] = useState<string | undefined>()
  const [カット日, setカット日] = useState<string>()
  const [積卸時間, set積卸時間] = useState<string>()
  const [積卸先ID, set積卸先ID] = useState<number>()
  const [積卸先コード, set積卸先コード] = useState<string>()
  const [積卸先名, set積卸先名] = useState<string>()
  const [積卸先都道府県, set積卸先都道府県] = useState<string>()
  const [積卸先市区町村, set積卸先市区町村] = useState<string>()
  const [海コン作業内容, set海コン作業内容] = useState<string>()
  const [運行部所コード, set運行部所コード] = useState<string>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  const [車輌ID, set車輌ID] = useState<number>()
  const [車番, set車番] = useState<string>()
  const [トレーラ車輌ID, setトレーラ車輌ID] = useState<number>()
  const [トレーラ車番, setトレーラ車番] = useState<string>()

  const [乗務員ID, set乗務員ID] = useState<number>()
  const [乗務員名, set乗務員名] = useState<string>()
  const [乗務員コード, set乗務員コード] = useState<string>()

  const [乗務員売上額, set乗務員売上額] = useState<number>()
  const [海コン付帯高速料, set海コン付帯高速料] = useState<number>()
  const [ETC情報, setETC情報] = useState<number>()

  const [乗務員食事手当, set乗務員食事手当] = useState<number>()
  const [海コン付帯作業手当, set海コン付帯作業手当] = useState<number>()
  const [海コン特別手当, set海コン特別手当] = useState<number>()
  const [同乗者1ID, set同乗者1ID] = useState<number>()
  const [同乗者1, set同乗者1] = useState<string>()
  const [同乗乗務員コード, set同乗乗務員コード] = useState<string>()

  const [傭車フラグ, set傭車フラグ] = useState<number>(0)
  const [工程備考, set工程備考] = useState<string>()
  const [更新日時, set更新日時] = useState<string>()

  const [海コン付帯作業区分コード, set海コン付帯作業区分コード] =
    useState<string>()
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  // combobox
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  // 海コン付帯作業区分
  const [海コン付帯作業区分ComboBox, set海コン付帯作業区分ComboBox] =
    useState<TWijmoComboBox<T区分マスタ["区分コード"], T区分マスタ> | null>(
      null
    )
  const [海コン付帯作業区分IsLoadEnded, set海コン付帯作業区分IsLoadEnded] =
    useState<boolean>(false)

  // 食事手当区分
  const [食事手当区分ComboBox, set食事手当区分ComboBox] =
    useState<TWijmoComboBox<number, T食事手当> | null>(null)
  const [食事手当区分IsLoadEnded, set食事手当区分IsLoadEnded] =
    useState<boolean>(false)
  const [食事手当ItemSource, set食事手当ItemSource] = useState<T食事手当[]>()

  // 傭車会社
  const [傭車会社ComboBox, set傭車会社ComboBox] = useState<TWijmoComboBox<
    string,
    T支払先
  > | null>(null)
  const [傭車会社isLoadEnded, set傭車会社isLoadEnded] = useState<boolean>(false)

  // 積卸先検索
  const [is積卸先検索Modal, setIs積卸先検索Modal] = useState(false)

  // 車輌検索
  const [is車輌検索Modal, setIs車輌検索Modal] = useState(false)
  const [車輌検索用部所コード, set車輌検索用部所コード] = useState<
    string | undefined
  >()

  const [原動機有無フラグ, set原動機有無フラグ] = useState<0 | 1>(0)
  const [, set請求車輌検索フラグ] = useState(true)

  // 乗務員検索
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)
  const [乗務員検索対象, set乗務員検索対象] = useState<"同乗者1" | "乗務員">(
    "乗務員"
  )

  // 車番とトレーラ車番
  const 車番AutoCompleteRef = useRef<wjrInput.AutoComplete>(null)
  const トレーラ車番AutoCompleteRef = useRef<wjrInput.AutoComplete>(null)

  // 傭車先検索
  const [is傭車先検索Modal, setIs傭車先検索Modal] = useState(false)
  // 傭車検索
  const [is傭車検索Modal, setIs傭車検索Modal] = useState(false)

  // 画面初期化フラグ
  const [comboDataInitialized, setComboDataInitialized] = useState(false)
  const [pageInitialized, setPageInitialized] = useState(false)

  const [共通ReadOnlyフラグ, set共通ReadOnlyフラグ] = useState(false)

  const [返却その他確認済ReadOnlyフラグ, set返却その他確認済ReadOnlyフラグ] =
    useState(false)

  //#endregion

  //#region [method]

  const getTumiOrosiSakiItemsSource: wjcInput.IGetItems = async (
    query,
    max,
    callback
  ) => {
    const 荷主コード = 荷主コードRef.current ?? ""

    if (荷主コード === "") {
      callback([])
      return
    }
    get積卸ItemsSourceByApi(query, max, callback, 荷主コード)
  }

  /**
   * 傭車オートフォーカス
   */
  const getYosyaItemsSource =
    (傭車コード: string): wjcInput.IGetItems =>
    async (
      query: string,
      max: number,
      callback: wjcInput.IGetItemsCallback
    ) => {
      if (傭車コード === "") {
        callback([])
        return
      }
      get傭車itemsSourceFunctionByApi(query, max, callback, 傭車コード)
    }

  const getSyaryoItemsSource =
    (原動機有無フラグ: 0 | 1): wjcInput.IGetItems =>
    async (
      query: string,
      max: number,
      callback: wjcInput.IGetItemsCallback
    ) => {
      const 部所コード =
        原動機有無フラグ === 1 ? 運行部所コードRef.current ?? "" : ""
      // トレーラ車番のときだけ、全部所のセミトレーラを検索対象とする
      let otherCondition: TSyaryoListGetReq | undefined = undefined
      if (部所コード === "" && 原動機有無フラグ === 1) {
        callback([])
        return
      }
      if (原動機有無フラグ === 0) {
        otherCondition = {
          車種区分コード: e車種区分.コンテナセミトレーラ,
        }
      }

      get車輌itemsSourceFunctionByApi(
        query,
        max,
        callback,
        原動機有無フラグ,
        部所コード,
        otherCondition
      )
    }

  /**
   * 乗務員フォーカスアウト時の動き
   */
  const get乗務員 = async (乗務員コード: string) => {
    try {
      return get乗務員Inner(乗務員コード)
    } catch (error) {
      dispatch(setAlerts(error))
    }
    return
  }

  //#region [handler]
  const 積卸先LostFocusHandler = (control: wjcInput.AutoComplete) => {
    if (control.selectedItem) {
      const 積卸先: T積卸先 = control.selectedItem
      set積卸先ID(積卸先.積卸先ID)
      set積卸先コード(積卸先.積卸先コード)
      set積卸先名(積卸先.積卸先略称)
      set積卸先都道府県(積卸先.住所１)
      set積卸先市区町村(積卸先.住所２)
    } else {
      // 修正前と変わってなければ特に処理せず抜ける
      if (pre積卸先コードRef.current === control.text) return

      // 1つしかアイテムがない場合、先頭を取得し埋め込む
      const itemsSource: T積卸先[] = control.itemsSource ?? []
      if (itemsSource.length === 1) {
        const 積卸先: T積卸先 = control.selectedItem
        set積卸先ID(積卸先.積卸先ID)
        set積卸先コード(積卸先.積卸先コード)
        set積卸先名(積卸先.積卸先略称)
        set積卸先都道府県(積卸先.住所１)
        set積卸先市区町村(積卸先.住所２)
      } else {
        set積卸先ID(undefined)
        set積卸先コード("")
        set積卸先名("")
        set積卸先都道府県("")
        set積卸先市区町村("")
      }
    }
  }

  const 車番AutoCompleteGotFocusHandler =
    (
      原動機有無: 0 | 1
    ): wjcCore.IEventHandler<wjcCore.Control, wjcCore.EventArgs> =>
    (autoComplete: wjcCore.Control, event: wjcCore.EventArgs) => {
      const control = autoComplete as wjcInput.AutoComplete
      pre車番Ref.current = control.text
      control.isEditable = 傭車フラグ === 1
      if (傭車フラグ === 0) {
        control.itemsSourceFunction = getSyaryoItemsSource(原動機有無)
      } else {
        control.itemsSourceFunction = getYosyaItemsSource(
          props.傭車会社コード ?? ""
        )
      }
    }

  const ヘッド車番GotFocusHandler = 車番AutoCompleteGotFocusHandler(1)

  const castヘッド車輌 = (ヘッド車輌: {
    車輌ID: number | undefined
    車番: string | undefined
    トレーラ車輌ID: number | undefined
    トレーラ車番: string | undefined
  }) => {
    set車輌ID(ヘッド車輌.車輌ID)
    set車番(ヘッド車輌.車番)
    // トレーラのデータも存在する場合、そちらも登録する
    if (ヘッド車輌.トレーラ車輌ID) {
      setトレーラ車輌ID(ヘッド車輌.トレーラ車輌ID)
      setトレーラ車番(ヘッド車輌.トレーラ車番)
    }
  }

  const castヘッド車輌乗務員 = (ヘッド車輌: {
    乗務員ID: number | undefined
    社員氏名: string | undefined
    社員コード: string | undefined
  }) => {
    if (ヘッド車輌.乗務員ID) {
      set乗務員ID(ヘッド車輌.乗務員ID)
      set乗務員名(ヘッド車輌.社員氏名)
      set乗務員コード(ヘッド車輌.社員コード)
    }
  }

  const ヘッド車番LostFocusHandler = (
    autoComplete: wjcCore.Control,
    event: wjcCore.EventArgs
  ) => {
    const control = autoComplete as wjcInput.AutoComplete
    // 傭車の場合
    if (傭車フラグ) {
      if (control.selectedItem) {
        const ヘッド傭車: T傭車マスタ = control.selectedItem
        set車番(ヘッド傭車.車番)
        set乗務員名(ヘッド傭車.乗務員名)
      } else if (
        !wjcCore.isNullOrWhiteSpace(control.text ?? "") &&
        control.itemsSource &&
        control.itemsSource.sourceCollection &&
        control.itemsSource.sourceCollection.length === 1
      ) {
        const ヘッド傭車: T傭車マスタ = control.itemsSource.sourceCollection[0]
        control.text = ヘッド傭車.車番
        set車番(ヘッド傭車.車番)
        set乗務員名(ヘッド傭車.乗務員名)
      } else {
        control.text = ""
        set車番("")
      }
      set車輌ID(undefined)
      return
    }

    if (control.selectedItem) {
      const ヘッド車輌: TSyaryoModalList = control.selectedItem
      castヘッド車輌(ヘッド車輌)
      // 乗務員も登録されていた場合、そちらも登録する
      castヘッド車輌乗務員(ヘッド車輌)
    } else {
      // テキストに変更がない場合特に処理せずスルー
      if (pre車番Ref.current === control.text) return

      // 1つしかアイテムがない場合、先頭を取得し埋め込む
      const itemsSource: TSyaryoModalList[] =
        control?.collectionView?.sourceCollection ?? []
      if (itemsSource.length === 1) {
        const ヘッド車輌: TSyaryoModalList = itemsSource[0]
        castヘッド車輌(ヘッド車輌)
        // 乗務員も登録されていた場合、そちらも登録する
        castヘッド車輌乗務員(ヘッド車輌)
      } else {
        set車輌ID(undefined)
        set車番("")
        control.text = ""
      }
    }
  }

  const トレーラ車番GotFocusHandler = 車番AutoCompleteGotFocusHandler(0)

  const トレーラ車番LostFocusHandler = (
    autoComplete: wjcCore.Control,
    event: wjcCore.EventArgs
  ) => {
    const control = autoComplete as wjcInput.AutoComplete
    // 傭車の場合
    if (傭車フラグ) {
      if (control.selectedItem) {
        const トレーラ傭車: T傭車マスタ = control.selectedItem
        setトレーラ車番(トレーラ傭車.車番)
      } else if (
        !wjcCore.isNullOrWhiteSpace(control.text ?? "") &&
        control.itemsSource &&
        control.itemsSource.sourceCollection &&
        control.itemsSource.sourceCollection.length === 1
      ) {
        const トレーラ傭車: T傭車マスタ =
          control.itemsSource.sourceCollection[0]
        control.text = トレーラ傭車.車番
        setトレーラ車番(トレーラ傭車.車番)
      } else {
        control.text = ""
        setトレーラ車番("")
      }
      setトレーラ車輌ID(undefined)
      return
    }
    // 通常車輌
    if (control.selectedItem) {
      const トレーラ車輌: TSyaryoModalList = control.selectedItem
      setトレーラ車輌ID(トレーラ車輌.車輌ID)
      setトレーラ車番(トレーラ車輌.車番)
    } else {
      // テキストに変更がない場合特に処理せずスルー
      if (preトレーラ車番Ref.current === control.text) return
      // 1つしかアイテムがない場合、先頭を取得し埋め込む
      const itemsSource: TSyaryoModalList[] =
        control?.collectionView?.sourceCollection ?? []
      if (itemsSource.length === 1) {
        const トレーラ車輌: TSyaryoModalList = itemsSource[0]
        setトレーラ車輌ID(トレーラ車輌.車輌ID)
        setトレーラ車番(トレーラ車輌.車番)
        // トレーラのデータも存在する場合、そちらも登録する
      } else {
        setトレーラ車輌ID(undefined)
        setトレーラ車番("")
        control.text = ""
      }
    }
  }

  const 傭車検索結果Set = (傭車: T傭車マスタ) => {
    switch (原動機有無フラグ) {
      case 1:
        // ヘッド
        set車輌ID(undefined)
        set車番(傭車.車番)
        // 乗務員も変更される
        // そのため乗務員IDを削除する
        set乗務員ID(undefined)
        set乗務員名(傭車.乗務員名)
        break
      case 0:
        // トレーラ
        setトレーラ車輌ID(undefined)
        setトレーラ車番(傭車.車番)
        break
      default:
        break
    }
  }

  //#endregion
  //#endregion

  //#region [effect]
  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    if (
      comboDataInitialized &&
      部所ComboBox &&
      海コン付帯作業区分ComboBox &&
      傭車会社ComboBox
    ) {
      setPageInitialized(true)
    }
  }, [
    comboDataInitialized,
    部所ComboBox,
    海コン付帯作業区分ComboBox,
    傭車会社ComboBox,
  ])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (pageInitialized) {
      // 初期値をログインユーザの部所コードとする
      set運行部所コード(userInfo.部所コード)
    }
  }, [pageInitialized])

  useEffect(() => {
    const data = props.initState
    set受注配車ID(data?.受注配車ID)
    set受注配車工程ID(data?.受注配車工程ID)
    set積卸日(data?.積卸日)
    set積卸時間(data?.積卸時間)
    set積卸先ID(data?.積卸先ID)
    set積卸先コード(data?.積卸先コード)
    set積卸先名(data?.積卸先名)
    set積卸先都道府県(data?.積卸先都道府県)
    set積卸先市区町村(data?.積卸先市区町村)
    set海コン作業内容(data?.海コン作業内容)
    set運行部所コード(data?.運行部所コード)
    set車輌ID(data?.車輌ID)
    set車番(data?.車番)
    setトレーラ車輌ID(data?.トレーラ車輌ID)
    setトレーラ車番(data?.トレーラ車番)
    set乗務員ID(data?.乗務員ID)
    set乗務員コード(data?.乗務員コード)
    set乗務員名(data?.乗務員名)
    set乗務員食事手当(data?.乗務員食事手当)
    set乗務員売上額(data?.乗務員売上額)
    set海コン付帯高速料(data?.海コン付帯高速料)
    set海コン付帯作業区分コード(data?.海コン付帯作業区分コード)
    set海コン付帯作業手当(data?.海コン付帯作業手当)
    set海コン特別手当(data?.海コン特別手当)

    set同乗者1ID(data?.同乗者乗務員ID)
    set同乗乗務員コード(data?.同乗乗務員コード)

    set同乗者1(data?.同乗者乗務員名)
    set傭車フラグ(data?.傭車フラグ ?? 0)
    set工程備考(data?.工程備考)
    setカット日(data?.カット日)

    set更新日時(data?.更新日時)
  }, [props.initState])

  useEffect(() => {
    let 支払先Data: T支払先 | undefined
    if (props.傭車会社コード != null && props.傭車会社コード !== "") {
      // 傭車会社コードより支払先IDを設定する
      支払先Data = props.支払先ItemSource?.find(
        (i) => i.支払先コード === props.傭車会社コード
      )
    }

    props.setState({
      ...props.initState,
      受注配車ID,
      受注配車工程ID,
      積卸日: 積卸日 ? 積卸日 : undefined,
      積卸時間,
      積卸先ID,
      積卸先コード,
      積卸先名,
      積卸先都道府県,
      積卸先市区町村,
      海コン作業内容,
      運行部所コード,
      車輌ID,
      車番,
      トレーラ車輌ID,
      トレーラ車番,
      乗務員ID,
      乗務員名,
      乗務員食事手当,
      海コン付帯作業手当,
      海コン付帯作業区分コード,
      海コン特別手当,
      海コン付帯高速料,
      乗務員売上額,
      支払先ID: 支払先Data?.支払先ID,
      傭車会社名: 支払先Data?.支払先名,
      傭車会社コード: 支払先Data?.支払先コード,
      同乗者乗務員ID: 同乗者1ID,
      同乗者乗務員名: 同乗者1,
      傭車フラグ,
      カット日,
      工程備考,
      更新日時,
    })
  }, [
    受注配車ID,
    受注配車工程ID,
    積卸日,
    積卸時間,
    積卸先コード,
    積卸先名,
    積卸先都道府県,
    積卸先市区町村,
    海コン作業内容,
    運行部所コード,
    props.傭車会社コード,
    車輌ID,
    車番,
    トレーラ車輌ID,
    トレーラ車番,
    乗務員名,
    乗務員売上額,
    海コン付帯高速料,
    乗務員食事手当,
    海コン付帯作業手当,
    海コン付帯作業区分コード,
    海コン付帯高速料,
    海コン特別手当,
    同乗者1,
    傭車フラグ,
    工程備考,
    カット日,
    更新日時,
  ])

  //TODO:部所情報の取得はどちらに持たせるか要検討
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      set部所ItemSource(部所ListRes.data)
      set区分ItemSource(区分マスタRes.data)
      const 食事手当item = 区分マスタRes.data.filter(
        (d) => d.分類コード === 区分分類コード.マスタ.食事手当区分
      )
      const items: T食事手当[] = []
      食事手当item.forEach((d) => {
        const item: T食事手当 = {
          name: d.名称1,
          value: d.数値1,
        }
        items.push(item)
      })
      set食事手当ItemSource(items)
      setComboDataInitialized(true)
    })
  }, [])

  useEffect(() => {
    荷主コードRef.current = props.ninusiCode
  }, [props.ninusiCode])

  useEffect(() => {
    運行部所コードRef.current = 運行部所コード
  }, [運行部所コード])

  useEffect(() => {
    // 初回設定時は動かさない
    if (props.isRestoreSearching) return

    if (区分ItemSource) {
      if (海コン付帯作業区分コード) {
        let 手当 = 区分ItemSource.filter(
          (d) =>
            d.分類コード ===
              区分分類コード.受注配車_請求支払.海コン付帯作業区分 &&
            d.区分コード === 海コン付帯作業区分コード
        )[0].数値1
        if (海コン付帯作業区分コード === e海コン付帯作業区分.フォーク作業) {
          // フォーク作業のみ特別手当として計上
          set海コン特別手当(手当)
        } else {
          set海コン特別手当(0)
          set海コン付帯作業手当(手当)
        }
      }
    }
  }, [海コン付帯作業区分コード])

  useEffect(() => {
    if (EtcData.length > 0) {
      setETC情報(
        _.sum(
          EtcData.filter(
            (d) => d.受注配車工程区分コード === props.initState?.工程区分コード
          ).map((d) => d.高速料 ?? 0)
        )
      )
    } else {
      setETC情報(0)
    }
  }, [EtcData])

  useEffect(() => {
    const is請求確認済 =
      props.請求額確認区分コード === e請求支払確認区分.確認済 ||
      請求処理状態区分List.includes(props.請求処理状態区分コード ?? "")

    set共通ReadOnlyフラグ(
      is請求確認済 &&
        ![e工程区分.その他, e工程区分.返却].some(
          (工程区分コード) => 工程区分コード === props.initState?.工程区分コード
        )
    )

    set返却その他確認済ReadOnlyフラグ(
      is請求確認済 &&
        [e工程区分.その他, e工程区分.返却].some(
          (工程区分コード) => 工程区分コード === props.initState?.工程区分コード
        )
    )
  }, [
    props.請求額確認区分コード,
    props.請求処理状態区分コード,
    props.initState?.工程区分コード,
  ])

  useEffect(() => {
    if (車番AutoCompleteRef.current) {
      // 傭車フラグのONOFFで車番は傭車を確認するように変更する。そのため、gotFocusを入れ替え
      const 車番autoComplete: wjcInput.AutoComplete =
        車番AutoCompleteRef.current.control
      車番autoComplete.gotFocus.removeAllHandlers()
      車番autoComplete.gotFocus.addHandler(ヘッド車番GotFocusHandler)
      車番autoComplete.lostFocus.removeAllHandlers()
      車番autoComplete.lostFocus.addHandler(ヘッド車番LostFocusHandler)
      車番autoComplete.refresh()
    }
    if (トレーラ車番AutoCompleteRef.current) {
      // 傭車フラグのONOFFで車番は傭車を確認するように変更する。そのため、gotFocusを入れ替え
      const トレーラ車番autoComplete: wjcInput.AutoComplete =
        トレーラ車番AutoCompleteRef.current.control
      トレーラ車番autoComplete.gotFocus.removeAllHandlers()
      トレーラ車番autoComplete.gotFocus.addHandler(トレーラ車番GotFocusHandler)
      トレーラ車番autoComplete.lostFocus.removeAllHandlers()
      トレーラ車番autoComplete.lostFocus.addHandler(
        トレーラ車番LostFocusHandler
      )
      トレーラ車番autoComplete.refresh()
    }
  }, [傭車フラグ, props.傭車会社コード])

  useEffect(() => {
    // 初回設定時は動かさない
    if (props.isRestoreSearching) return
    // 処理伝播用傭車フラグが ONになったときのみ、OFFの物をすべてONにする
    if (
      props.処理伝播用傭車フラグ === 1 &&
      props.処理伝播用傭車フラグ !== 傭車フラグ
    ) {
      set傭車フラグ(props.処理伝播用傭車フラグ)
    }
  }, [props.処理伝播用傭車フラグ])
  //#endregion

  //className用条件式

  //カット日に入力してある日付より、返却日に入力されている日付のほうが遅い場合
  // カット日・返却日を赤背景にする
  // カット日は入力されているが、返却日が入力されていない場合
  // カット日のみ赤字

  const has返却時カット日Error =
    props.initState?.工程区分コード === e工程区分.返却 &&
    wjcCore.isNullOrWhiteSpace(積卸日 ?? "") &&
    !wjcCore.isNullOrWhiteSpace(カット日 ?? "")

  const has返却日カット日逆転Error =
    props.initState?.工程区分コード === e工程区分.返却 &&
    !wjcCore.isNullOrWhiteSpace(積卸日 ?? "") &&
    !wjcCore.isNullOrWhiteSpace(カット日 ?? "") &&
    dayjs(積卸日).diff(dayjs(カット日), "D") > 0

  const 積卸日ClassName = util.addTextWithStartDelimiter(
    "w-12rem",
    [
      has返却日カット日逆転Error ? "input-date-warning" : "",
      has返却日カット日逆転Error ? "background" : "",
    ],
    " "
  )

  const カット日ClassName = util.addTextWithStartDelimiter(
    "w-12rem",
    [
      has返却時カット日Error || has返却日カット日逆転Error
        ? "input-date-warning"
        : "",
      has返却日カット日逆転Error ? "background" : "",
      has返却時カット日Error ? "text" : "",
    ],
    " "
  )

  return (
    <>
      <tr>
        {/* 作業工程 */}
        <th className={`kotei-cell-color-${props.initState?.工程区分コード}`}>
          {props.initState?.工程区分名称1}
        </th>
        {/* 作業日 */}
        <td>
          <DateInput
            placeholder=""
            value={積卸日}
            // 返却の際に、積卸日がカット日より後の場合、赤字になるようにする
            className={積卸日ClassName}
            defaultValue={null}
            showHoliday={true}
            setValue={(v) => {
              v != null ? set積卸日(v) : set積卸日(undefined)
            }}
            isDisabled={共通ReadOnlyフラグ}></DateInput>
        </td>
        {/* フリータイム・カット */}
        <td>
          {/* PICK 返却のみ */}
          {(props.initState?.工程区分コード === e工程区分.PICK ||
            props.initState?.工程区分コード === e工程区分.返却) && (
            <DateInput
              placeholder={
                props.initState?.工程区分コード === e工程区分.PICK
                  ? "フリータイム"
                  : "カット"
              }
              value={カット日}
              // 返却の際に、カット日入力済で積卸日空の場合、赤字になるようにする
              className={カット日ClassName}
              defaultValue={null}
              showHoliday={true}
              setValue={(v) => {
                v != null ? setカット日(v) : setカット日(undefined)
              }}
              isDisabled={共通ReadOnlyフラグ}></DateInput>
          )}
        </td>
        {/* 時間 */}
        <td>
          <TextInput
            className="w-12rem"
            name="作業時間"
            placeholder=""
            value={積卸時間}
            setValue={(v) => {
              set積卸時間(v)
            }}
            isReadOnly={共通ReadOnlyフラグ}></TextInput>
        </td>
        {/* 積卸先コード */}
        <td>
          <div className="d-flex">
            <wjrInput.AutoComplete
              className="w-10rem"
              headerPath={"積卸先コード"}
              text={積卸先コード}
              showDropDownButton={false}
              minLength={1}
              gotFocus={(control: wjcInput.AutoComplete) => {
                // 変更前後を確認
                pre積卸先コードRef.current = control.text
                control.itemsSourceFunction = getTumiOrosiSakiItemsSource
              }}
              lostFocus={積卸先LostFocusHandler}
              isDisabled={共通ReadOnlyフラグ}
              displayMemberPath={"displayName"}
              selectedValuePath={"積卸先コード"}></wjrInput.AutoComplete>
            <button
              type="button"
              className="icon-button"
              onClick={(e) => {
                e.preventDefault()
                setIs積卸先検索Modal(true)
              }}>
              <FontAwesomeIcon
                className="icon-button-inner"
                icon={faSearch}></FontAwesomeIcon>
            </button>
          </div>
        </td>
        {/* 社名（ヤード） */}
        <td>
          <div className="d-flex">
            <TextInput
              className="w-10rem"
              name="社名"
              value={積卸先名}
              setValue={set積卸先名}
              isReadOnly={共通ReadOnlyフラグ}></TextInput>
          </div>
        </td>
        {/* 都道府県 */}
        <td>
          <TextInput
            className="w-12rem"
            name="積卸先都道府県"
            placeholder=""
            value={積卸先都道府県}
            setValue={(v) => {
              set積卸先都道府県(v)
            }}
            isReadOnly={共通ReadOnlyフラグ}></TextInput>
        </td>
        {/* 市区町村 */}
        <td>
          <TextInput
            className="w-12rem"
            name="積卸先市区町村"
            placeholder=""
            value={積卸先市区町村}
            setValue={(v) => {
              set積卸先市区町村(v)
            }}
            isReadOnly={共通ReadOnlyフラグ}></TextInput>
        </td>
        {/* 作業内容 */}
        <td>
          {/* PICKと返却には存在しない */}
          {(props.initState?.工程区分コード === e工程区分.作業 ||
            props.initState?.工程区分コード === e工程区分.その他) && (
            <TextInput
              className="w-12rem"
              name="海コン作業内容"
              placeholder=""
              value={海コン作業内容}
              setValue={(v) => {
                set海コン作業内容(v)
              }}
              isReadOnly={共通ReadOnlyフラグ}></TextInput>
          )}
        </td>
        {/* 運行部所 */}
        <td>
          <ComboBox.Busyo
            className="w-12rem"
            isEmpty={true}
            itemsSource={部所ItemSource}
            isLoadEnded={部所IsLoadEnded}
            setIsLoadEnded={set部所IsLoadEnded}
            listFilter={(d) => d.運行部所フラグ === 1}
            setSelectedValue={(v) => {
              v != null ? set運行部所コード(v) : set運行部所コード(undefined)
            }}
            selectedValue={運行部所コード}
            ComboBox={部所ComboBox}
            setComboBox={set部所ComboBox}
            isDisabled={共通ReadOnlyフラグ}></ComboBox.Busyo>
        </td>
        {/* 傭車会社 */}
        <td>
          <div className="d-flex">
            <CheckInput
              label=""
              type="checkbox"
              onClick={(control) => {
                if (control.currentTarget.value === "1") {
                  // ONにした場合運行系の情報をクリアする

                  set車輌ID(undefined)
                  set車番("")
                  setトレーラ車輌ID(undefined)
                  setトレーラ車番("")
                  set乗務員ID(undefined)
                  set乗務員コード(undefined)
                  set乗務員名(undefined)
                  set乗務員売上額(0)
                  set海コン付帯高速料(0)
                  set乗務員食事手当(0)
                }
              }}
              isDisabled={共通ReadOnlyフラグ}
              setValue={set傭車フラグ}
              value={傭車フラグ}></CheckInput>
            <ComboBox.SiharaiSaki
              siharaiSaki={e支払先区分.傭車先}
              className={傭車フラグ === 0 ? "w-12rem invisible" : "w-12rem"}
              isLoadEnded={傭車会社isLoadEnded}
              setIsLoadEnded={set傭車会社isLoadEnded}
              isReadOnly={傭車フラグ === 0}
              isRequired={false}
              isEmpty={true}
              isDisabled={共通ReadOnlyフラグ}
              lostFocus={(control) => {
                // 傭車選択時点で車輌の情報は消す
                if (control.selectedItem) {
                  set車輌ID(undefined)
                  set車番("")
                }
              }}
              itemsSource={props.支払先ItemSource}
              selectedValue={props.傭車会社コード}
              setSelectedValue={(v) => {
                props.set傭車会社コード(v ?? "")
              }}
              ComboBox={傭車会社ComboBox}
              setComboBox={set傭車会社ComboBox}></ComboBox.SiharaiSaki>

            {!共通ReadOnlyフラグ && 傭車フラグ === 1 && (
              <button
                type="button"
                className="icon-button"
                onClick={(e) => {
                  e.preventDefault()
                  setIs傭車先検索Modal(true)
                }}>
                <FontAwesomeIcon
                  className="icon-button-inner"
                  icon={faSearch}></FontAwesomeIcon>
              </button>
            )}
          </div>
        </td>
        {/* 車番 */}
        <td>
          <div className="d-flex">
            <wjrInput.AutoComplete
              className="w-6rem"
              headerPath={"車番"}
              ref={車番AutoCompleteRef}
              text={車番}
              minLength={1}
              isRequired={false}
              isEditable={true}
              showDropDownButton={false}
              gotFocus={ヘッド車番GotFocusHandler}
              lostFocus={ヘッド車番LostFocusHandler}
              isDisabled={共通ReadOnlyフラグ}
              displayMemberPath={"displayName"}
              selectedValuePath={"車番"}></wjrInput.AutoComplete>
            <button
              type="button"
              className="icon-button"
              disabled={共通ReadOnlyフラグ}
              onClick={(e) => {
                e.preventDefault()
                set原動機有無フラグ(1)

                set車輌検索用部所コード(運行部所コード)
                傭車フラグ === 0
                  ? setIs車輌検索Modal(true)
                  : setIs傭車検索Modal(true)
              }}>
              <FontAwesomeIcon
                className="icon-button-inner"
                icon={faSearch}></FontAwesomeIcon>
            </button>
            <TextInput
              id="車輌ID"
              name="車輌ID"
              style={{
                width: "4.75rem",
              }}
              value={車輌ID?.toString()}
              setValue={() => {}}
              isReadOnly
              placeholder="ID"
            />
          </div>
        </td>
        {/* トレーラ車番 */}
        <td>
          <div className="d-flex">
            <wjrInput.AutoComplete
              className="w-6rem"
              headerPath={"車番"}
              ref={トレーラ車番AutoCompleteRef}
              text={トレーラ車番}
              isRequired={false}
              isEditable={true}
              minLength={1}
              showDropDownButton={false}
              gotFocus={トレーラ車番GotFocusHandler}
              lostFocus={トレーラ車番LostFocusHandler}
              isDisabled={共通ReadOnlyフラグ}
              displayMemberPath={"displayName"}
              selectedValuePath={"車番"}></wjrInput.AutoComplete>
            <button
              type="button"
              className="icon-button"
              disabled={共通ReadOnlyフラグ}
              onClick={(e) => {
                e.preventDefault()
                set原動機有無フラグ(0)
                set車輌検索用部所コード(運行部所コード)
                傭車フラグ === 0
                  ? setIs車輌検索Modal(true)
                  : setIs傭車検索Modal(true)
              }}>
              <FontAwesomeIcon
                className="icon-button-inner"
                icon={faSearch}></FontAwesomeIcon>
            </button>
            <TextInput
              id="トレーラ車輌ID"
              name="トレーラ車輌ID"
              style={{
                width: "4.75rem",
              }}
              value={トレーラ車輌ID?.toString()}
              setValue={() => {}}
              isReadOnly
              placeholder="ID"
            />
          </div>
        </td>
        {/* 乗務員 */}
        <td>
          <div className="d-flex">
            <TextInput
              style={{ width: "5rem" }}
              isReadOnly={共通ReadOnlyフラグ || 傭車フラグ === 1}
              id="乗務員"
              name="乗務員コード"
              onBlur={async (e) => {
                if (乗務員コード && 乗務員コード !== "") {
                  const inner乗務員 = await get乗務員(乗務員コード)
                  set乗務員ID(inner乗務員?.乗務員ID)
                  set乗務員名(inner乗務員?.社員氏名)
                  set乗務員コード(inner乗務員?.社員コード)
                } else {
                  set乗務員ID(undefined)
                  set乗務員名("")
                  set乗務員コード("")
                }
              }}
              value={乗務員コード}
              setValue={(v) => {
                set乗務員コード(v)
                if (v === "" || !v) {
                  set乗務員ID(undefined)
                }
              }}
              maxLength={4}
              placeholder="社員CD"
            />
            {(共通ReadOnlyフラグ || 傭車フラグ === 0) && (
              <button
                type="button"
                className="icon-button"
                onClick={(e) => {
                  e.preventDefault()
                  set乗務員検索対象("乗務員")
                  setIs乗務員検索Modal(true)
                }}>
                <FontAwesomeIcon
                  className="icon-button-inner"
                  icon={faSearch}></FontAwesomeIcon>
              </button>
            )}
            <TextInput
              className="w-10rem"
              name="乗務員"
              value={乗務員名}
              setValue={set乗務員名}
              isReadOnly={共通ReadOnlyフラグ || 傭車フラグ === 0}></TextInput>
          </div>
        </td>
        {/* 乗務員売上額 */}
        <td>
          <wjrInput.InputNumber
            className="w-12rem"
            value={乗務員売上額}
            handleWheel={false}
            valueChanged={(c: wjcInput.InputNumber, e: any) => {
              c.value != null
                ? set乗務員売上額(c.value)
                : set乗務員売上額(undefined)
            }}
            format={"n0"}
            isReadOnly={共通ReadOnlyフラグ || 傭車フラグ === 1}
            isRequired={false}></wjrInput.InputNumber>
        </td>
        {/* 付帯高速料 */}
        <td>
          <wjrInput.InputNumber
            className="w-12rem"
            value={海コン付帯高速料}
            isReadOnly={共通ReadOnlyフラグ || 返却その他確認済ReadOnlyフラグ}
            handleWheel={false}
            valueChanged={(c: wjcInput.InputNumber, e: any) => {
              c.value != null
                ? set海コン付帯高速料(c.value)
                : set海コン付帯高速料(undefined)
            }}
            format={"n0"}
            isRequired={false}></wjrInput.InputNumber>
        </td>
        {/* ETC情報 */}
        <td>
          <wjrInput.InputNumber
            className="w-12rem"
            value={ETC情報}
            handleWheel={false}
            valueChanged={(c: wjcInput.InputNumber, e: any) => {
              c.value != null ? setETC情報(c.value) : setETC情報(undefined)
            }}
            format={"n0"}
            isReadOnly={true}
            isRequired={false}></wjrInput.InputNumber>
        </td>
        {/* 食事手当 */}
        <td>
          <ComboBox.Default
            className="w-6rem"
            isLoadEnded={食事手当区分IsLoadEnded}
            setIsLoadEnded={set食事手当区分IsLoadEnded}
            displayTextFormatter={(item: T食事手当) => {
              return item.value.toString()
            }}
            isAllSelect={false}
            isEmpty={true}
            itemsSource={食事手当ItemSource}
            selectedValue={乗務員食事手当}
            setSelectedValue={(v) => {
              v != null ? set乗務員食事手当(v) : set乗務員食事手当(undefined)
            }}
            ComboBox={食事手当区分ComboBox}
            setComboBox={set食事手当区分ComboBox}
            isDisabled={
              共通ReadOnlyフラグ || 傭車フラグ === 1
            }></ComboBox.Default>
        </td>
        {/* 同乗者 */}
        <td>
          <div className="d-flex">
            <TextInput
              style={{ width: "5rem" }}
              isReadOnly={共通ReadOnlyフラグ || 傭車フラグ === 1}
              id="同乗者"
              name="同乗乗務員コード"
              onBlur={async (e) => {
                if (同乗乗務員コード == null || 同乗乗務員コード === "") {
                  set同乗者1ID(undefined)
                  set同乗者1(undefined)
                  set同乗乗務員コード(undefined)
                  return
                }
                const inner乗務員 = await get乗務員(同乗乗務員コード)
                set同乗者1ID(inner乗務員?.乗務員ID)
                set同乗者1(inner乗務員?.社員氏名)
                set同乗乗務員コード(inner乗務員?.社員コード)
              }}
              value={同乗乗務員コード}
              setValue={(v) => {
                set同乗乗務員コード(v)
                if (v === "" || !v) {
                  set同乗者1ID(undefined)
                }
              }}
              maxLength={4}
              placeholder="社員CD"
            />
            {(共通ReadOnlyフラグ || 傭車フラグ === 0) && (
              <button
                type="button"
                className="icon-button"
                onClick={(e) => {
                  e.preventDefault()
                  set乗務員検索対象("同乗者1")
                  setIs乗務員検索Modal(true)
                }}>
                <FontAwesomeIcon
                  className="icon-button-inner"
                  icon={faSearch}></FontAwesomeIcon>
              </button>
            )}
            <TextInput
              className="w-10rem"
              name="同乗者1"
              value={同乗者1}
              setValue={set同乗者1}
              isReadOnly={共通ReadOnlyフラグ || 傭車フラグ === 0}></TextInput>
          </div>
        </td>
        {/* 付帯作業手当 */}
        <td>
          <ComboBox.Kubun
            className="w-12rem"
            分類コード={区分分類コード.受注配車_請求支払.海コン付帯作業区分}
            isLoadEnded={海コン付帯作業区分IsLoadEnded}
            setIsLoadEnded={set海コン付帯作業区分IsLoadEnded}
            isAllSelect={false}
            isEmpty={true}
            itemsSource={区分ItemSource}
            selectedValue={海コン付帯作業区分コード}
            setSelectedValue={(v) => {
              v != null
                ? set海コン付帯作業区分コード(v)
                : set海コン付帯作業区分コード(undefined)
            }}
            isReadOnly={
              共通ReadOnlyフラグ ||
              傭車フラグ === 1 ||
              返却その他確認済ReadOnlyフラグ
            }
            ComboBox={海コン付帯作業区分ComboBox}
            setComboBox={set海コン付帯作業区分ComboBox}></ComboBox.Kubun>
        </td>
        <td>
          <wjrInput.InputNumber
            className={"w-4rem"}
            value={海コン付帯作業手当}
            handleWheel={false}
            valueChanged={(c: wjcInput.InputNumber, e: any) => {
              c.value != null
                ? set海コン付帯作業手当(c.value)
                : set海コン付帯作業手当(undefined)
            }}
            isRequired={false}
            isReadOnly={共通ReadOnlyフラグ || 返却その他確認済ReadOnlyフラグ}
            format={"n0"}></wjrInput.InputNumber>
          <wjrInput.InputNumber
            className={"w-4rem ms-1"}
            value={海コン特別手当}
            handleWheel={false}
            valueChanged={(c: wjcInput.InputNumber, e: any) => {
              c.value != null
                ? set海コン特別手当(c.value)
                : set海コン特別手当(undefined)
            }}
            isRequired={false}
            isReadOnly={true}
            format={"n0"}></wjrInput.InputNumber>
        </td>
        <td>
          <div className="d-flex">
            <TextInput
              className="w-10rem"
              name="工程備考"
              value={工程備考}
              setValue={set工程備考}
              isReadOnly={共通ReadOnlyフラグ}></TextInput>
          </div>
        </td>
        {/* 作業工程 */}
        <th className={`kotei-cell-color-${props.initState?.工程区分コード}`}>
          {props.initState?.工程区分名称1}
        </th>
      </tr>
      {/* 積卸先検索 */}
      <TumiOrosiSakiSearchModal
        size="lg"
        setIsShow={setIs積卸先検索Modal}
        isShow={is積卸先検索Modal}
        ninusiCode={props.ninusiCode}
        setTumiOrosiSaki={(積卸先) => {
          set積卸先ID(積卸先.積卸先ID)
          set積卸先コード(積卸先.積卸先コード)
          set積卸先名(積卸先.積卸先略称)
          set積卸先市区町村(積卸先.住所２ ?? "")
          set積卸先都道府県(積卸先.住所１ ?? "")
        }}></TumiOrosiSakiSearchModal>
      {/* 車輌検索 */}
      <SyaryoSearchModal
        setIsShow={(v) => {
          set請求車輌検索フラグ(v)
          setIs車輌検索Modal(v)
        }}
        isShow={is車輌検索Modal}
        busyoCode={車輌検索用部所コード}
        原動機有無フラグ={原動機有無フラグ}
        setSyaryo={(車輌) => {
          if (原動機有無フラグ === 1) {
            // 車輌
            set車輌ID(車輌.車輌ID)
            set車番(車輌.車番)
            // トレーラのデータも存在する場合、そちらも登録する
            if (車輌.トレーラ車輌ID) {
              setトレーラ車輌ID(車輌.トレーラ車輌ID)
              setトレーラ車番(車輌.トレーラ車番)
            }
            // 乗務員も登録されていた場合、そちらも登録する
            if (車輌.乗務員ID) {
              set乗務員ID(車輌.乗務員ID)
              set乗務員名(車輌.社員氏名)
              set乗務員コード(車輌.社員コード)
            }
          } else {
            // トレーラ車輌
            setトレーラ車番(車輌.車番)
            setトレーラ車輌ID(車輌.車輌ID)
          }
        }}></SyaryoSearchModal>
      {/* 乗務員検索 */}
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        setZyomuin={(乗務員) => {
          switch (乗務員検索対象) {
            case "乗務員":
              set乗務員ID(乗務員.乗務員ID)
              set乗務員名(乗務員.社員氏名)
              set乗務員コード(乗務員.社員コード)
              break
            case "同乗者1":
              set同乗者1ID(乗務員.乗務員ID)
              set同乗者1(乗務員.社員氏名)
              set同乗乗務員コード(乗務員.社員コード)
              break
            default:
              break
          }
        }}></ZyomuinSearchModal>
      {/* 傭車先検索 */}
      <SiharaisakiSearchModal
        siharaisakiKubun={"傭車先"}
        isShow={is傭車先検索Modal}
        setIsShow={setIs傭車先検索Modal}
        setSiharaisaki={(支払先) => {
          props.set傭車会社コード(支払先.支払先コード)
        }}></SiharaisakiSearchModal>
      {/* 傭車検索 */}
      <YosyaSearchModal
        setIsShow={setIs傭車検索Modal}
        isShow={is傭車検索Modal}
        isReadOnly={true}
        yosyaSakiCode={props.傭車会社コード}
        setYosya={傭車検索結果Set}></YosyaSearchModal>
    </>
  )
}

export default SagyoGridRow
